export default __webpack_public_path__ + "static/media/you-can-do-it-1024w.a327f959.png";